import { IEmailTemplate } from 'susy-common/models';

export enum EmailTemplatesActionType {
    GET_ALL_EMAIL_TEMPLATES,
    GET_EMAIL_TEMPLATE,
    UPDATE_EMAIL_TEMPLATE,
}

export interface GetAllEmailTemplatesAction {
    type: EmailTemplatesActionType.GET_ALL_EMAIL_TEMPLATES;
    payload: Array<IEmailTemplate>;
}

export interface GetEmailTemplateAction {
    type: EmailTemplatesActionType.GET_EMAIL_TEMPLATE;
    payload: IEmailTemplate;
}

export interface UpdateEmailTemplateAction {
    type: EmailTemplatesActionType.UPDATE_EMAIL_TEMPLATE;
    payload: IEmailTemplate;
}

export type EmailTemplateAction =
    | GetAllEmailTemplatesAction
    | GetEmailTemplateAction
    | UpdateEmailTemplateAction;

